// ─── Barrel: re-export everything from the poi/ sub-modules ───────────────────

// Types and constants
export type { PoiKind } from "./types";
export type { ParsedPoi, DetourInfo } from "./poi/types";
export {
  getPoiColorClass,
  KIND_FILL,
  KIND_BORDER,
  formatDuration,
} from "./poi/types";

// Query
export { buildOverpassQuery } from "./poi/query";
export { detectKind, parsePoiResults } from "./poi/parse";

// Icons
export { makePoiIcon, makePoiIconWithColor } from "./poi/icons";

// State
export {
  togglePoiSelected,
  isPoiSelected,
  clearSelectedPois,
  getSelectedPoiIds,
  restoreSelectedPois,
  setOnSelectionChange,
  getVisiblePois,
  getFilteredCount,
  setShowOnlySelected,
  setSelectedCount,
  setOnVisibilityChange,
  notifyVisibilityChange,
  setFilterCheckbox,
} from "./poi/state";

// Render
export {
  buildPoiContent,
  renderPois,
  setPoiList,
  sortPoisByArrival,
  rerenderPoiList,
  rerenderMarkers,
} from "./poi/render";
import { setPoiClickHandler as _setPoiClickHandler } from "./poi/render";
export { _setPoiClickHandler as setPoiClickHandler };

// Search
export { searchPois, drawPolygons } from "./poi/search";

// Detour (backwards compat — delegates to detour.ts)
export { fetchDetourInfo } from "./detour";
